module.exports = __webpack_public_path__ + "img/item_icon8.175c11d0.png";